import { http } from '../utils/http'

export const UABASE = '/aicc-ua'
export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')

/**
 * 获取SkillGroup列表
 */
export const getSkillGroupSetting = ({ skillId }) => {
  const params = {
    skillId
  }
  return new Promise((resolve, reject) => {
    http.get(`${UABASE}/skill/getSkillGroupSetting`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加技能组用户
 */
export const addSkillGroupSetting = ({ data }) => {
  return new Promise((resolve, reject) => {
    http.post(`${UABASE}/skill/addSkillGroupSetting`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取技能组快捷回复信息
 */
export const getSkillGroupQuickReplys = ({ skillGroupId, pageNum, pageSize, searchText, searchCategory, searchTitle }) => {
  const params = {
    skillGroupId,
    pageNum,
    pageSize,
    searchText,
    searchCategory,
    searchTitle
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/quickReply/getAllQRs`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const updateQuickReplys = async ({ quickReplys, skillGroupId }) => {
  const params = {
    skillGroupId: skillGroupId
  }
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/quickReply/updateQRs`, { data: quickReplys, params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const addQuickReply = async ({ quickReplys, skillGroupId }) => {
  const params = {
    skillGroupId: skillGroupId
  }
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/quickReply/insertQR`, { data: quickReplys, params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const exportQuickReply = async ({ skillGroupId }) => {
  const params = {
    skillGroupId
  }
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/quickReply/export`, { responseType: 'blob', params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const deleteQRByIds = async (ids) => {
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/quickReply/deleteQRByIds`, { data: ids }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const synchQRMsg = async (synchSgIds, params) => {
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/quickReply/synchQRMsg`, { data: synchSgIds, params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
